module.exports = __webpack_public_path__ + "static/media/paypal-logo.3aa691b4.webp";